// The one place feed `kind` → glyph mapping lives. `chip` wraps it in the small
// rounded tile the left column / detail header use; without it, it's a bare
// inline glyph (entry rows, the reader header).
import type { FeedKind } from "@/feeds/model/wire.js";
import { IconRss, IconSubstack, IconTwitch, IconYoutube } from "@/platform/ui";

export function FeedKindIcon({
  kind,
  size = 11,
  chip = false,
}: {
  kind: FeedKind;
  size?: number;
  chip?: boolean;
}) {
  const glyph =
    kind === "youtube" ? (
      <IconYoutube size={size} />
    ) : kind === "twitch" ? (
      <IconTwitch size={size} />
    ) : kind === "substack" ? (
      <IconSubstack size={size} />
    ) : (
      <IconRss size={size} />
    );
  if (!chip) return glyph;
  return (
    <span className="flex h-6 w-6 flex-none items-center justify-center rounded-md bg-surface-2 text-ink-soft">
      {glyph}
    </span>
  );
}
